import React, { useRef } from "react";
import { Button, Tag } from "antd";
import {
  PlusOutlined,
  UndoOutlined,
  CloseOutlined,
  FilterOutlined,
} from "@ant-design/icons";
import { DateRangeSelect } from "src/components/DateRangeSelect";
import { FilterConditionPanel } from "src/search/components/inputs/question-input/FilterConditionPanel";
import { Condition, SearchState } from "src/search/types";
import { usePopupContext } from "src/hooks/usePopup";
import { conditionKey } from "src/utils/fields";

export function BoardFilters({ board }: { board: any }) {
  const popup = usePopupContext();
  const filterBtnRef = useRef<HTMLButtonElement>(null);

  // Render filter pills from board.globalState
  const filters = board.globalState.filters || [];

  // Add filter panel logic (popup)
  const handleAddFilter = () => {
    const anchor = filterBtnRef.current;
    if (!anchor) return;
    popup.setPopup(
      anchor,
      <FilterConditionPanel
        initialValue={{}}
        value={{ filters: filters }}
        onApply={(data) => {
          if ("filters" in data) {
            board.setGlobalState({
              ...board.globalState,
              filters: data.filters as Condition[],
            });
          } else if (data.field && data.operator && data.values?.length) {
            const newCondition: Condition = {
              ...data.field,
              comparison: { [data.operator]: data.values } as any,
              key: conditionKey({
                ...data.field,
                comparison: { [data.operator]: data.values } as any,
                key: "",
              } as Condition),
            };
            const merged: Condition[] = [
              ...(filters || []).filter(
                (f: Condition) => f.key !== newCondition.key
              ),
              newCondition,
            ];
            board.setGlobalState({
              ...board.globalState,
              filters: merged,
            });
          }
          popup.close();
        }}
        onCancel={() => popup.close()}
        showAppliedSummary
      />
    );
  };

  return (
    <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
      <DateRangeSelect
        duration={
          board.globalState.duration &&
          String(board.globalState.duration) !== ""
            ? board.globalState.duration
            : undefined
        }
        startDate={board.globalState.startDate}
        endDate={board.globalState.endDate}
        onChangeDuration={(val) => {
          board.setGlobalState({
            ...board.globalState,
            duration: val,
            startDate: null,
            endDate: null,
          });
        }}
        onChangeRange={([start, end]) => {
          board.setGlobalState({
            ...board.globalState,
            duration: undefined,
            startDate: start,
            endDate: end,
          });
        }}
      />
      <Button
        icon={<FilterOutlined />}
        onClick={handleAddFilter}
        ref={filterBtnRef}
        type="default"
      >
        {filters.length > 0 && <span>{filters.length}</span>}
      </Button>
    </div>
  );
}

export default BoardFilters;
